import React from 'react';

type IProps = {
  techBanner: string;
};

export const DestinationDetailsTechBanner = ({ techBanner }: IProps) => {
  return (
    <p
      className={
        'inline-block rounded-lg bg-overlay p-3 font-semibold text-gray'
      }
    >
      {techBanner}
    </p>
  );
};
